import _ from 'lodash';
import templateStr from 'text!./pa-confirmation.html';
import './pa-confirmation.scss';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        controller: ['$scope', function ($scope) {
            this._getCoveragesForVehicle = (veh) => {
                return veh.coverages.filter((cov) => {
                    return cov.selected;
                })
                    .map((vehicleCov) => {
                        return {
                            name: `${veh.vehicleName} - ${vehicleCov.name}`,
                            amount: vehicleCov.amount
                        };
                    });
            };

            this._coverages = function () {
                const lineCoverages = $scope.chosenQuote.lobs.personalAuto.lineCoverages
                    .filter((cov) => {
                        return cov.selected;
                    })
                    .map((lineCov) => {
                        return {
                            name: lineCov.name,
                            amount: lineCov.amount
                        };
                    });
                const coveragesForVehicles = $scope.chosenQuote.lobs.personalAuto.vehicleCoverages
                    .map(this._getCoveragesForVehicle);

                return lineCoverages.concat(_.flatten(coveragesForVehicles));
            };

            $scope.coverages = this._coverages();
        }]
    };
}];
